import React from 'react'
import { Bar, Radar } from "react-chartjs-2";

import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';
import HorizontalBarChartStacked from '../../CustomChart/HorizontalBarChartStacked';
import { flatten } from "lodash";

const Measure = (props) => {

    // const labelList = ["1", "2", "3", "4"]
    const labelList = [["Have measured", "the Company's", "carbon footprint"], ["Have set", "targets to", "reduce", "carbon emissions"], ["We use", "digital tools", "for carbon", "accounting"], "Other"]

    const horizontalStackData = {
        labels: props?.measure?.map(item => Object.keys(item)[0]?.split(" ")),
        
        datasets: [
        
            {
                data: props?.measure ? flatten(props?.measure?.map(item => parseInt(Object.values(item)))) : [],
                backgroundColor: "#34A853",
                hoverBackgroundColor: "green",
                label: '',
                borderRadius: 5,
            },
            {
                data: props?.measure ? flatten(props?.measure?.map(item => 100 - parseInt(Object.values(item)))) : [],
                backgroundColor: "#EA4335",
                hoverBackgroundColor: "red",
                label: '',
                borderRadius: 5,
            }, 
        ]
    };

    const horizontalStackOptions = {
        responsive: true,
        
        scales: {
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                stacked: true,
            },
            y: {
                max: 100,
                ticks: {
                    // display: false,
                    callback: function(value, index, ticks) {
                        return `${value}%`;
                    }
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                // title: {
                //     display: true,
                //     text: 'Average Score'
                // },
                stacked: true,
            },
            xAxes: [
                {
                    scaleLabel: {
                        display: false
                    },
                    gridLines: {
                        display: false
                    },
                    stacked: true,
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false,
                    },
                    stacked: true,
                }
            ]
        },

        plugins: {
            legend: {
                display: false,
            },
            
            datalabels: {
                anchor: 'end',
                // clamp: false,
                align: 'start',
                color: "white",
                display: function (context) {
                    return context.dataset.data[context.dataIndex] > 0;
                },
                font: {
                    weight: "bold",
                },
                formatter: (value) => {
                    return `${value}%`
                },
            },
        },
        
        pointLabelFontFamily: "Quadon Extra Bold",
        scaleFontFamily: "Quadon Extra Bold",
    };

    return (
        <div className='p-2'>
            <h5 className='mb-3'>Measure</h5>
            <div>
                <HorizontalBarChartStacked data={horizontalStackData} options={horizontalStackOptions}/>
            </div>
            <h6 className='fw-bold text-dark text-center mt-3'>How has the Company measured its progress over the past year?</h6>
        </div>
    )
};

export default Measure